import type {CourseApiModel} from '../../../api/course';
import type {Nullable} from '../../utility-types';

import {isMeCoachForEntity} from '../isMeCoachForEntity';
import {getCourseDurationString} from './getCourseDurationString';

type Variant = 'default' | 'read_duration_string' | 'read_label';

export function getCourseLabel(course?: Nullable<Partial<CourseApiModel>>) {
  const variant = getVariant(course);

  switch (variant) {
    case 'read_duration_string': {
      return getCourseDurationString(course);
    }
    case 'read_label': {
      return course?.label || '';
    }
    default: {
      return '';
    }
  }
}

function getVariant(course?: Nullable<Partial<CourseApiModel>>): Variant {
  if (!course) {
    return 'default';
  }

  const shouldReadLabel = Boolean(course.label) && isMeCoachForEntity(course);

  return shouldReadLabel ? 'read_label' : 'read_duration_string';
}
